import '../../../styles/skelton/project-card-skelton.scss';

const ProjectCardSkeleton = () => {
  return (
    <div className="project-card action skeleton">
      <div className="project-card-body">
        <div className="project-card-icon skeleton-icon" />
        <div className="project-card-text">
          <div className="skeleton-line skeleton-title" />
          <div className="skeleton-line skeleton-value" />
        </div>
      </div>
    </div>
  );
};

export default ProjectCardSkeleton;
